import RemoteGuide from 'common-module/src/util/guide';
import Vue from 'vue';

RemoteGuide.install();
Vue.prototype.$remoteGuide = RemoteGuide;

